<ng-container *ngIf="mayShowBreadcrumbs">
	<kendo-breadcrumb
		(itemClick)="onItemClick($event)"
		[items]="($breadcrumbs | async) ?? []"
	>
	</kendo-breadcrumb>
</ng-container>
